import React from 'react';
import { packItems } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-190" data-mp="yvr11dwvo5qs">
      <div className="mx-auto max-w-4xl" data-id="element-191" data-mp="yto8on8960iw">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-192" data-mp="kx13xya2662f">
          Cosa c&apos;è dentro il pacchetto INGLESE PRONTO™?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-193" data-mp="b5de21t5gx32">
          {packItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex flex-col rounded-2xl bg-sand px-6 py-8 text-center" data-id="element-194" data-mp="2605dbcuocje">
                <span className="mx-auto inline-flex h-10 w-10 items-center justify-center rounded-full bg-white text-brand" data-id="element-195" data-mp="75cszybjpnn1">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-196" data-mp="3ofauifybxgbp" />
                </span>
                <h3 className="mt-4 font-display text-base font-bold text-ink" data-id="element-197" data-mp="3te5jjzmw4149">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-ink/55" data-id="element-198" data-mp="37v31rvlr6qiw">
                  {item.text}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}